import { useQuery } from '@tanstack/react-query';
import { retrieveByTripId } from '../services/chats';

export const useChatQuery = (trip_id: string | undefined) => {
    if (!trip_id) {
        throw Error("Отсутствует идентификатор заявки");
    }

    return useQuery({
        queryFn: () => retrieveByTripId(parseInt(trip_id)),
        queryKey: ['chat', trip_id],
        // staleTime: 1000 * 5,
        refetchOnWindowFocus: false,
    });
};
